module.exports = __webpack_public_path__ + "static/media/feature.9c56ba94.jpg";